import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const InventoryStats = ({ stats, lowStockItems = [] }) => {
  const [showLowStockDropdown, setShowLowStockDropdown] = useState(false);

  const statCards = [
    {
      label: 'Total Items',
      value: stats?.totalItems,
      icon: 'Package',
      color: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-50 dark:bg-blue-950/30'
    },
    {
      label: 'Categories',
      value: stats?.totalCategories,
      icon: 'Layers',
      color: 'text-purple-600 dark:text-purple-400',
      bgColor: 'bg-purple-50 dark:bg-purple-950/30'
    },
    {
      label: 'Low Stock',
      value: stats?.lowStockItems,
      icon: 'AlertTriangle',
      color: 'text-orange-600 dark:text-orange-400',
      bgColor: 'bg-orange-50 dark:bg-orange-950/30',
      isDropdown: true
    },
    {
      label: 'Total Units',
      value: stats?.totalUnits,
      icon: 'Hash',
      color: 'text-emerald-600 dark:text-emerald-400',
      bgColor: 'bg-emerald-50 dark:bg-emerald-950/30'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="relative">
          <div
            className={`bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 ${
              stat?.isDropdown ? 'cursor-pointer hover:border-orange-400 dark:hover:border-orange-500 transition-colors' : ''
            }`}
            onClick={stat?.isDropdown ? () => setShowLowStockDropdown(!showLowStockDropdown) : undefined}
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
                <Icon name={stat?.icon} size={20} className={stat?.color} />
              </div>
              {stat?.isDropdown && (
                <Icon 
                  name={showLowStockDropdown ? "ChevronUp" : "ChevronDown"} 
                  size={20} 
                  className="text-muted-foreground"
                />
              )}
            </div>
            <div className="text-2xl md:text-3xl font-semibold text-foreground data-text mb-1">
              {stat?.value}
            </div>
            <div className="text-xs md:text-sm text-muted-foreground">
              {stat?.label}
            </div>
          </div>

          {stat?.isDropdown && showLowStockDropdown && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-lg z-10 max-h-64 overflow-y-auto">
              {lowStockItems?.length > 0 ? (
                <div className="p-3">
                  <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 px-2">
                    Low Stock Items
                  </div>
                  <div className="space-y-1">
                    {lowStockItems?.map((item) => (
                      <div
                        key={item?.id}
                        className="flex items-center justify-between p-2 rounded hover:bg-muted/50 transition-colors"
                      >
                        <div className="flex-1 min-w-0">
                          <div className="text-sm font-medium text-foreground truncate">
                            {item?.name}
                          </div>
                          <div className="text-xs text-muted-foreground">
                            {item?.category}
                          </div>
                        </div>
                        <div className="flex items-center gap-2 ml-2">
                          <div className="text-sm font-semibold text-orange-600 dark:text-orange-400">
                            {item?.quantity} {item?.unit}
                          </div>
                          <Icon name="AlertTriangle" size={16} className="text-orange-600 dark:text-orange-400" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="p-4 text-center">
                  <Icon name="CheckCircle" size={32} className="text-emerald-600 dark:text-emerald-400 mx-auto mb-2" />
                  <p className="text-sm text-muted-foreground">All items are well stocked!</p>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default InventoryStats;